import { render } from "./BannerTwo.vue?vue&type=template&id=441a9742&scoped=true"
import script from "./BannerTwo.vue?vue&type=script&lang=js"
export * from "./BannerTwo.vue?vue&type=script&lang=js"

import "./BannerTwo.vue?vue&type=style&index=0&id=441a9742&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441a9742"]])

export default __exports__